import {createAction} from '@reduxjs/toolkit'

import {PayMethodVoucherType} from '@web/core/constants'

/** 상품권 ID 입력 */
export const inputVoucherId = createAction<{
    type: PayMethodVoucherType
    id: string
}>('voucher/inputVoucherId')

/** 상품권 PW 입력 */
export const inputVoucherPinNo = createAction<{
    type: PayMethodVoucherType
    pinNo: string
}>('voucher/inputVoucherPinNo')

/** 상품권 사용 가능 금액 수정 */
export const updateVoucherBalance = createAction<{
    type: PayMethodVoucherType
    balance: Maybe<number>
}>('voucher/updateVoucherBalance')

/** 상품권 사용 정보 수정 */
export const updateVoucherLoginInfo = createAction<{
    type: PayMethodVoucherType
    voucherInfo: {
        custId: string
        certNo: string
        loginSuccessId: string
        balance: number
        sid?: string
        tid?: string
    }
}>('voucher/updateVoucherLoginInfo')
